import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { fetchSocialProfile } from "../../client/manager/cross-posting";
import type { AyrshareProfileRow, LinkedAccount } from "../../models/ayrshare";
import { crossPostingQueryKeys } from "./queryKeys";

type SocialProfileResult = {
  profile: AyrshareProfileRow | null;
  connectedAccounts: LinkedAccount[];
};

/**
 * Fetch the Ayrshare profile + linked accounts for a comedian.
 * Returns `{ profile: null, connectedAccounts: [] }` when no profile exists.
 *
 * staleTime 5min per CONTEXT.md D-03 (profile rarely changes).
 */
export function useSocialProfile(
  comedianId: string
): UseQueryResult<SocialProfileResult, Error> {
  return useQuery({
    queryKey: crossPostingQueryKeys.socialProfile(comedianId),
    queryFn: () => fetchSocialProfile(comedianId),
    enabled: !!comedianId,
    staleTime: 5 * 60 * 1000,
  });
}
